//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from 'routes/Route';
import UserGroupDelete from './delete';
import UserGroupEdit from './edit';
import UserGroup from './list';

export const FilterUserGroup = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[2] !== "user_group") {
      setFilter({
        search: "",
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterUserGroup.Provider value={{ filter, setFilter }}>
      <Route path="/user_group" exact component={UserGroup} isPrivate/>
      <Route path="/user_group/add" exact component={UserGroupEdit} isPrivate/>
      <Route path="/user_group/edit/:id" exact component={UserGroupEdit} isPrivate/>
      <Route path="/user_group/delete/:id" exact component={UserGroupDelete} isPrivate/>
    </FilterUserGroup.Provider>
  )
}  